import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/react'

function PageHeader({ img_path, title, breadcrumb, className }) {
    return (
        <div
            className={className}
            css={css`
                background-image: url(${img_path});
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 40vh;
                overflow: hidden;
                padding-bottom: 20px;
            `}
        >
            {title && (
                <h1
                    className={`text-4xl ${breadcrumb && ''}`}
                    css={css`
                        color: #fff;
                        margin-top: 12px;
                    `}
                >
                    {title}
                </h1>
            )}
            {breadcrumb && (
                <div
                    className="text-white px-3 py-2 mt-0 relative top-12"
                    css={css`
                        color: #fff;
                        background-color: rgba(255, 255, 255, 0.4);
                    `}
                >
                    {Array.isArray(breadcrumb)
                        ? breadcrumb.join(' > ')
                        : breadcrumb + ''}
                </div>
            )}
        </div>
    )
}

PageHeader.propTypes = {
    img_path: PropTypes.string,
    title: PropTypes.string,
    breadcrumb: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ])
}

export default PageHeader
